import { createFileRoute } from "@tanstack/react-router";
import { WorkPage } from "./work";

export const Route = createFileRoute("/industries")({
  head: () => ({
    meta: [
      {
        title: "Industries & Case Work — KMWAdvertising · Strategic Media Systems",
      },
      {
        name: "description",
        content:
          "Explore the vertical-specific media systems and growth frameworks KMWAdvertising builds across Gaming, FMCG, Real Estate, Healthcare, D2C, Hospitality, and Enterprise.",
      },
      {
        property: "og:title",
        content: "Industries & Case Work — KMWAdvertising",
      },
      {
        property: "og:description",
        content:
          "We build vertical-specific media systems tailored for measurable business growth across traditional and digital channels.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: WorkPage,
});
